import { apiRequest } from "./apiClient";

function query(values = {}) {
  const params = new URLSearchParams();
  Object.entries(values).forEach(([key, value]) => {
    if (value !== "" && value !== undefined && value !== null) params.set(key, value);
  });
  return params.toString();
}
export const listDevices = values => apiRequest(`/api/devices?${query(values)}`);
export const getDevice = id => apiRequest(`/api/devices/${id}`);
export const listDeviceOperators = () => apiRequest("/api/devices/operators");
export const listAvailableAccounts = values => apiRequest(`/api/devices/available-accounts?${query(values)}`);
export const createDevice = values => apiRequest("/api/devices", { method: "POST", body: JSON.stringify(values) });
export const updateDevice = (id, values) => apiRequest(`/api/devices/${id}`, { method: "PUT", body: JSON.stringify(values) });
export const attachDeviceAccount = (id, accountId) => apiRequest(`/api/devices/${id}/account`, { method: "PUT", body: JSON.stringify({ accountId }) });
